export default function Forms() {
  return (
    <div>
      <p>Forms</p>
    </div>
  );
}
